module.exports = "button{margin-right:8px}"